/**
 * 用户信息
 */
export interface UserInfo {
  name: string;
  code: string;
  token: string;
  role: string;
  headImagePath: string;
}

/** 用户hooks */
const useUserHooks = () => {
  /** 获得用户信息 */
  const getUserInfo = (): UserInfo => {
    const {
      name, code, token, role, headImagePath,
    } = JSON.parse(sessionStorage.getItem('heroUserStore') || '{}');
    return {
      name, code, token, role, headImagePath,
    };
  };

  /** 退出登录-清除缓存 */
  const logout = (): void => {
    sessionStorage.clear();
    localStorage.clear();
  };

  return { getUserInfo, logout };
};

export default useUserHooks;
